declare var authServerUrl: string;
declare var publicURL: string

export const handleProvider = (
  provider: "Google" | "Facebook",
  endpoint: 'login' | 'signup',
  location: any
) => {
  window.open(
    `${authServerUrl}/external/${endpoint}?provider=${provider}&${location.search.slice(1)}`,
    "_self"
  );
};

export const handleSocialSignUp = (provider: "Google" | "Facebook", location: any) => {
  const returnUrl = `${publicURL}/externalRegister?${location.search.slice(1)}`
  window.open(
    `${authServerUrl}/external/signup?provider=${provider}&ReturnUrl=${returnUrl}`,
    "_self"
  );
}